export class SiteOfflineBypassFormRequestModel {
	Password: string = '';
}
